import React, { Component } from 'react';
import { CalibratedProduct } from '../../components';

export default class CalibratedProductContainer extends Component {
  constructor(props) {
    super(props);
    const productLogoTexts = [
      { regex: /RS CAL|RSCAL/, text: 'RS CAL' },
      { regex: /UKAS CAL|UKAS/, text: 'UKAS CAL' },
      { regex: /SYS CAL|SYSCAL/, text: 'SYS CAL' },
    ];
    const rsWebProductModel = window.rs.web.product.model;
    const labels = window.rs.web.product.model.labels.calibratedProducts;
    const calibratedProducts = rsWebProductModel.calibratedProducts.map(item => {
      let productLogoText = (productLogoTexts.find(v => {
        return v.regex.test(item.description.toUpperCase());
      }));

      productLogoText = productLogoText != null ? productLogoText.text : 'CAL';
      return { ...item, productLogoText };
    });

    this.state = {
      calibratedProducts,
      labels,
    };
  }

  render() {
    return (
      <div className="calibrated-products">
        {this.state.calibratedProducts.map(item => (
          <CalibratedProduct {...item} labels={this.state.labels} key={item.id} />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/CalibratedProducts/CalibratedProduct.js